import { useInfiniteQuery } from '@tanstack/react-query';
import { PostFilterDto } from 'src/api/FiretrolApiClient';
import { postApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export interface IPostSearchParams {
  filters: PostFilterDto;
  sort: string;
  postType: string;
  query: string;
}

/** @registry Paginated job activity feed; every filter/sort change starts a new page set. */
export function usePostSearch(
  jobId: number | null | undefined,
  params: IPostSearchParams,
) {
  return useInfiniteQuery({
    queryKey: queryKeys.posts.search(jobId ?? -1, params),
    queryFn: ({ pageParam, signal }) =>
      postApiClient.searchPosts(
        jobId!,
        { filters: params.filters },
        params.sort,
        params.postType,
        params.query,
        pageParam,
        toCancelToken(signal),
      ),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.meta.currentPage < lastPage.meta.lastPage
        ? lastPage.meta.currentPage + 1
        : undefined,
    enabled: jobId != null && jobId > 0,
    meta: { errorContext: 'activity feed' },
  });
}
